// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.moderation-img {\n    width: 482px;\n    height: 100%;\n}\n@media (max-width: 767px) {\n.moderation-img {\n        width: 100%;\n        height: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
